import { useState, useCallback } from 'react';

export interface AttendanceTarget {
  id: string;
  title: string;
  time: string;
}

export function useSessionAttendance() {
  const [attendanceSession, setAttendanceSession] = useState<AttendanceTarget | null>(null);

  const openAttendance = useCallback((target: AttendanceTarget) => setAttendanceSession(target), []);
  const closeAttendance = useCallback(() => setAttendanceSession(null), []);

  return { attendanceSession, openAttendance, closeAttendance };
}
